<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-11-13 17:16:16
 * @FilePath: \mrc-ess-fronted\src\Page\Ess\Approval\Approval\components\backTo.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-03-09 13:14:47
-->
<template>
  <normalDialog
    :title="$t('label_essweb_RosterRecordForm_form_backToTitle')"
    @close="closeDialog"
    width="600"
    :dialog="show"
  >
    <template v-slot:content>
      <v-form ref="form" lazy-validation>
        <v-row>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet
              class="d-flex flex-row align-center"
              @click="
                previewNode == 0 ? ((previewNode = 1), (previewMan = 0)) : null
              "
            >
              <v-rating
                v-model="previewNode"
                size="25"
                class="mx-2"
                readonly
                background-color="primary "
                color="primary"
                empty-icon="radio_button_unchecked"
                full-icon="radio_button_checked"
                :length="1"
                dense
              />
              {{
                $t("label_essweb_approvalApplication_form_back_preNodeLabel")
              }}
            </v-sheet>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet
              class="d-flex flex-row align-center"
              @click="
                previewMan == 0 ? ((previewMan = 1), (previewNode = 0)) : null
              "
            >
              <v-rating
                size="25"
                readonly
                class="mx-2"
                v-model="previewMan"
                background-color="primary "
                color="primary"
                :length="1"
                dense
                empty-icon="radio_button_unchecked"
                full-icon="radio_button_checked"
              />
              {{ $t("label_essweb_approvalApplication_form_back_preManLabel") }}
            </v-sheet>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template v-slot:actions>
      <CardActions okBtn @cancel="closeDialog" @ok="toSubmit" />
    </template>
  </normalDialog>
</template>
<script>
export default {
  name: "backToNode",
  props: {
    show: { default: false, type: Boolean },
    curUuid: { default: null, type: String },
  },
  computed: {
    curSender() {
      return this.previewNode == 1 ? 0 : 1;
    },
  },
  watch: {
    show(vl) {
      if (!vl) {
        this.previewMan = 0;
        this.previewNode = 1;
      }
    },
  },
  mounted() {},
  data() {
    return {
      previewMan: 0,
      previewNode: 1,
    };
  },
  methods: {
    closeDialog: function () {
      this.$emit("close");
    },

    toSubmit: function () {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$emit("back", this.curSender);
    },
  },
};
</script>